<template>
  <v-app id="inspire">
    <div>
      <base-header />
    </div>
    <v-content class="content mt-2" :class="`${$vuetify.breakpoint.xs ? '' : 'mb-5'}`">
          <router-view />
    </v-content>
    <div>
      <base-footer />
    </div>
  </v-app>
</template>

<script>
import BaseFooter from "./components/base-footer.vue"
import BaseHeader from "./components/base-header.vue"


export default {
  name: "App",
  components: {
    BaseFooter,
    BaseHeader,
  },
  watch: {
    $route(to) {
      if (to.name == "error") return;
    },
  },
};
</script>
<style>
@import './assets/styles/style.css';
.content {
    background-color: #f9f9f9;
}
</style>
